import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
//
import loginPageStyle from "stylesheets/views/loginPageStyle.jsx";
// Layout
import { Auth as AuthLayout } from 'layouts';
// Auth
import AuthHelperMethods from 'components/Auth/AuthHelperMethods.jsx';
// import withAuth from 'components/Auth/withAuth.jsx';

// @material-ui/icons
import Email from "@material-ui/icons/Email";
import Check from "@material-ui/icons/Check";

// External
// import compose from 'recompose/compose';;

const { REACT_APP_SERVER_URL } = process.env;

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: [],
      errors: {}
    };
  }

  Auth = new AuthHelperMethods();

  login = async e => {
    e.preventDefault();

    const { history } = this.props;

    const fields = ["username", "password"];
    const formElements = e.target.elements;

    const formValues = fields
      .map(field => ({
        [field]: formElements.namedItem(field).value
      }))
      .reduce((current, next) => ({ ...current, ...next }));

    let loginRequest;
    try {
      loginRequest = await axios.post(
        `http://${REACT_APP_SERVER_URL}/login`,
        {
          ...formValues
        },
        {
          withCredentials: true
        }
      );
    } catch ({ response }) {
      loginRequest = response;
    }
    const { data: loginRequestData } = loginRequest;
    if (loginRequestData.success) {
      return history.push("/dashboard");
    }

    this.setState({
      errors: loginRequestData.messages && loginRequestData.messages.errors
    });
  };

  handleFormSubmit = e => {
    e.preventDefault();

    const formElements = e.target.elements;
    const username = formElements.namedItem("username").value;
    const password = formElements.namedItem("password").value;
    /* Here is where all the login logic will go. Once verified, it should store your token and send you to the protected route. */

    this.Auth.login(username, password)
       .then(res => {
         if (res === false) {
           return alert("Sorry those credentials don't exist!");
         }
         this.props.history.replace("/");
       })
       .catch(err => {
         alert(err);
       });
  };

  handleToggle = value => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked
    });
  };
  render() {
    const { classes } = this.props;
    const { errors } = this.state;
    return (
      <AuthLayout>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={8}>
              <h4 className={classes.textCenter} style={{ marginTop: 0 }}>
                Log in to see how you can speed up your Real Estate business with the
                lighteningh social CRM and more.{" "}
              </h4>
            </GridItem>
          </GridContainer>
          <GridContainer justify="center">
            <GridItem xs={12} sm={6} md={4}>
              <form onSubmit={this.handleFormSubmit}>
                <Card className={classes[this.state.cardAnimaton]}>
                  <CardHeader
                    className={`${classes.cardHeader} ${classes.textCenter}`}
                    color="primary"
                  >
                    <h4 className={classes.cardTitle}>Log in</h4>
                    <div className={classes.socialLine}>
                      {[
                        "fab fa-facebook-square",
                        "fab fa-twitter",
                        "fab fa-google-plus"
                      ].map((prop, key) => {
                        return (
                          <Button
                            color="transparent"
                            justIcon
                            key={key}
                            className={classes.customButtonClass}
                          >
                            <i className={prop} />
                          </Button>
                        );
                      })}

                    </div>
                  </CardHeader>
                  <CardBody>
                    <p
                      className={`${classes.textCenter} ${classes.checkboxLabel}`}
                    >
                      Or Sign in with <strong>demo@kinos.es</strong> and the
                      password <strong>secret</strong>{" "}
                    </p>
                    <CustomInput
                      labelText="Email..."
                      id="email"
                      error={errors.username || errors.invalidEmailOrPassword}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.formControlClassName
                      }}
                      inputProps={{
                        required: true,
                        name: "username",
                        endAdornment: (
                          <InputAdornment position="end">
                            <Email className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        )
                      }}
                    />
                    <CustomInput
                      labelText="Password"
                      id="password"
                      error={errors.password || errors.invalidEmailOrPassword}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.formControlClassName
                      }}
                      inputProps={{
                        type: "password",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputAdornmentIcon}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        )
                      }}
                    />
                    <FormControlLabel
                      classes={{
                        root:
                          classes.checkboxLabelControl +
                          " " +
                          classes.checkboxLabelControlClassName,
                        label: classes.checkboxLabel
                      }}
                      control={
                        <Checkbox
                          tabIndex={-1}
                          onClick={() => this.handleToggle(1)}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                          }}
                        />
                      }
                      label={<span>Remember me</span>}
                    />
                  </CardBody>
                  <CardFooter className={classes.justifyContentCenter}>
                    <Button type="submit" color="primary" simple size="lg" block>
                      Let's Go
                    </Button>
                  </CardFooter>
                </Card>
              </form>
            </GridItem>
          </GridContainer>
        </div>
      </AuthLayout>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object,
  errors: PropTypes.object
};

export default withStyles(loginPageStyle)(LoginPage);
